import Vue from "vue";
import Router from "vue-router";
import IndexPage from '../views/index/index.vue';
import LoginPage from '../views/login/index.vue';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index-page',
      component: IndexPage
    },
    {
      path: '/login',
      name: 'login-page',
      component: LoginPage
    },
  ]
})

export default router;